import 'angular:locale/data:de-DE';
import 'angular:locale/data:nl-BE';
import 'angular:locale/data:fr-LU';
import 'angular:locale/data:fr-BE';
import 'angular:locale/data:fr-FR';
import 'angular:locale/data:en-US';
import 'zone.js';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
